const asString = (value: unknown): string => {
  if (typeof value === 'string') {
    return value;
  }
  if (Array.isArray(value)) {
    return typeof value[0] === 'string' ? value[0] : '';
  }
  return '';
};

export interface ContentModeKeyParts {
  mainComponent?: string;
  subComponent?: string;
  subComponentIdentifier?: string;
}

/**
 * Build a stable content mode key.
 * Priority:
 * 1) mainComponent + subComponent + subComponentIdentifier
 * 2) mainComponent + subComponent
 * 3) mainComponent
 * 4) default
 */
export function buildContentModeKey(parts: ContentModeKeyParts): string {
  const main = (parts.mainComponent ?? '').trim();
  const sub = (parts.subComponent ?? '').trim();
  const identifier = (parts.subComponentIdentifier ?? '').trim();

  if (main && sub && identifier) {
    return `${main}::${sub}::${identifier}`;
  }
  if (main && sub) {
    return `${main}::${sub}`;
  }
  if (main) {
    return main;
  }
  return 'default';
}

export function buildContentModeKeyFromRouteParams(params: Record<string, unknown>): string {
  return buildContentModeKey({
    mainComponent: asString(params.mainComponent),
    subComponent: asString(params.subComponent),
    subComponentIdentifier: asString(params.subComponentIdentifier),
  });
}
